import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  MenuItem,
  Popper,
  Paper,
  ClickAwayListener,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // or your preferred HTTP client
import { getHeader } from "../../utils/util";

const DebouncedSearchBox = ({
  apiUrl,
  placeholder = "Search...",
  size = "small",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  // Debounce function
  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Fetch data from backend
  const fetchData = async (term) => {
    if (!term.trim()) {
      setResults([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(apiUrl, {
        params: { name: term },
        ...getHeader(),
      });
      setResults(response.data);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching search results:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  // Debounced version of fetchData
  const debouncedFetch = useCallback(
    debounce((term) => fetchData(term), 300),
    []
  );

  // Handle input change
  const handleChange = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
    debouncedFetch(value);
  };

  // Handle item selection
  const handleItemClick = (item) => {
    navigate(`/home/${item.id}/template-campaign`);
    setOpen(false);
    setSearchTerm("");
  };

  // Close dropdown when clicking away
  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <div>
      <TextField
        fullWidth
        size={size}
        variant="outlined"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleChange}
        inputRef={(node) => {
          setAnchorEl(node);
        }}
        InputProps={{
          endAdornment: loading ? "Loading..." : null,
        }}
      />

      <Popper
        open={open && results.length > 0}
        anchorEl={anchorEl}
        placement="bottom-start"
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            elevation={3}
            style={{
              width: anchorEl?.clientWidth,
              maxHeight: 300,
              overflow: "auto",
            }}
          >
            {results.map((item) => (
              <MenuItem
                key={item.id}
                onClick={() => handleItemClick(item)}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <div>{item.name}</div>
                  <div style={{ fontSize: "0.8rem", color: "#666" }}>
                    {item.category} | {item.status}
                  </div>
                </div>
              </MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default DebouncedSearchBox;
